import React from 'react'

const BrainIcon = (props) => {
  return (
   
   <svg version="1.0" xmlns="http://www.w3.org/2000/svg" className={props.className}
    width="65px" height="65px" viewBox="0 0 400.000000 400.000000"
    preserveAspectRatio="xMidYMid meet"  >
   
   <g transform="translate(0.000000,400.000000) scale(0.100000,-0.100000)"
   fill="green" className={props.className} stroke="none">
   <path d="M2725 3566 c-62 -28 -108 -80 -132 -146 l-18 -50 -122 0 -123 0 -2
   -227 -3 -228 -112 -3 -111 -3 -4 208 c-3 203 -4 209 -30 259 -67 128 -221 179
   -346 115 -78 -40 -142 -137 -142 -216 0 -21 -4 -26 -16 -21 -64 24 -151 10
   -213 -34 -41 -30 -81 -93 -81 -129 0 -18 -6 -19 -78 -14 -66 5 -85 2 -130 -17
   -60 -26 -125 -93 -143 -147 -11 -34 -8 -143 5 -173 5 -12 -4 -19 -36 -28 -70
   -19 -103 -46 -133 -107 -23 -47 -27 -64 -22 -107 4 -28 15 -68 25 -89 l19 -38
   -27 -11 c-58 -24 -110 -105 -110 -170 0 -39 24 -98 53 -128 l22 -24 -25 -16
   c-107 -70 -149 -215 -94 -324 28 -56 94 -116 146 -134 l48 -15 -22 -29 c-33
   -45 -36 -127 -8 -186 28 -57 96 -104 151 -104 l38 0 -1 -58 c-1 -67 26 -129
   69 -160 40 -28 100 -45 134 -38 28 5 29 5 29 -37 0 -47 30 -120 63 -155 32
   -35 107 -70 164 -78 46 -6 120 4 166 21 14 6 17 2 17 -21 1 -68 64 -154 144
   -197 31 -16 58 -21 111 -21 78 0 118 15 173 68 66 62 72 83 79 321 l6 215 128
   0 129 0 2 -228 3 -227 124 -5 124 -5 12 -43 c18 -58 56 -106 113 -139 39 -24
   58 -28 117 -28 101 1 172 43 218 130 33 63 31 165 -6 228 -72 123 -229 159
   -347 81 -44 -29 -85 -86 -98 -135 l-8 -34 -97 -3 -97 -3 0 216 c0 130 -4 224
   -10 236 -10 17 -23 19 -160 19 l-150 0 0 135 0 135 420 0 c392 0 421 -1 426
   -17 27 -86 81 -150 150 -179 47 -20 141 -17 190 5 86 39 138 122 138 221 0
   100 -58 188 -150 226 -44 19 -136 18 -182 -2 -66 -27 -128 -101 -145 -174 l-6
   -25 -398 2 c-219 2 -408 3 -420 3 l-23 0 0 355 0 356 88 -3 87 -3 3 -132 c3
   -157 -15 -142 180 -146 l133 -2 19 -55 c55 -165 273 -215 396 -91 120 119 84
   322 -70 392 -49 22 -143 25 -190 5 -66 -28 -146 -121 -146 -171 0 -13 -20 -15
   -135 -15 l-134 0 -3 133 -3 132 -112 3 -113 3 0 139 0 140 405 0 404 0 11 -38
   c27 -100 124 -172 232 -172 70 0 111 16 163 61 50 44 77 106 77 178 0 240
   -305 333 -440 135 -13 -20 -28 -51 -34 -70 l-9 -34 -404 0 -405 0 0 135 0 135
   124 0 c68 0 131 3 140 6 14 5 16 36 16 235 l0 229 100 0 99 0 11 -40 c15 -57
   68 -120 124 -149 157 -81 349 36 350 214 0 178 -180 296 -339 221z m185 -56
   c22 -11 52 -39 67 -62 23 -34 28 -53 28 -103 0 -52 -5 -68 -29 -103 -52 -76
   -147 -101 -232 -63 -78 36 -118 120 -100 216 8 42 58 103 101 121 45 20 120
   17 165 -6z m-975 -73 c21 -12 53 -42 70 -65 l30 -44 3 -890 2 -890 -36 6 c-19
   4 -62 19 -94 33 l-59 25 25 38 c66 99 72 229 18 378 -11 29 -21 42 -34 42 -30
   0 -32 -16 -10 -87 29 -93 29 -193 0 -261 -34 -80 -43 -83 -95 -32 -24 24 -54
   63 -67 86 -23 44 -53 58 -64 29 -9 -22 44 -110 100 -166 58 -57 152 -108 249
   -134 l68 -18 -3 -413 -3 -412 -31 -38 c-50 -62 -78 -78 -147 -82 -51 -3 -70 1
   -107 20 -115 62 -140 213 -52 310 41 46 72 63 162 92 51 17 65 25 65 41 0 17
   -6 20 -40 18 -22 -1 -67 -11 -100 -24 -73 -27 -168 -116 -180 -168 -9 -43 -71
   -71 -159 -71 -79 0 -140 29 -180 88 -25 35 -30 52 -29 97 2 67 31 134 72 166
   18 13 44 35 59 48 24 22 25 24 7 37 -15 11 -23 10 -55 -6 -40 -20 -91 -73
   -114 -119 -48 -92 -206 -23 -206 90 0 12 10 41 21 65 27 53 20 79 -19 70 -77
   -17 -91 -18 -126 -1 -135 64 -76 276 78 279 39 1 53 -5 112 -49 10 -7 18 -5
   29 6 14 14 14 18 -4 41 -43 55 -133 73 -216 44 -153 -54 -299 126 -225 278 25
   52 56 77 126 103 65 25 68 46 10 72 -88 38 -114 138 -55 205 39 45 81 54 150
   31 63 -21 135 -16 207 15 52 22 71 45 52 64 -7 7 -30 3 -72 -12 -83 -29 -155
   -29 -199 1 -53 35 -79 82 -79 139 0 60 22 101 68 130 29 18 43 20 98 14 55 -6
   65 -4 71 10 3 9 1 24 -6 33 -58 80 -68 116 -52 179 38 138 219 194 326 101 37
   -33 54 -74 64 -153 5 -42 9 -51 26 -51 17 0 20 8 23 55 4 62 -17 125 -56 172
   -69 81 13 207 135 208 60 0 89 -16 124 -72 42 -66 102 -100 166 -96 41 3 48 6
   51 26 3 19 -1 22 -33 22 -92 0 -157 69 -158 167 0 84 45 157 118 189 48 21
   134 17 180 -9z m1267 -707 c76 -21 138 -102 138 -180 0 -78 -62 -159 -138
   -180 -54 -14 -71 -13 -129 14 -139 65 -140 261 -1 330 57 29 75 31 130 16z
   m-265 -645 c113 -67 109 -249 -7 -313 -50 -28 -92 -35 -139 -22 -111 30 -170
   152 -122 255 49 107 163 141 268 80z m329 -470 c162 -82 128 -310 -53 -349
   -45 -10 -107 10 -150 47 -107 94 -73 264 63 312 56 20 84 18 140 -10z m-306
   -809 c85 -56 106 -185 43 -264 -44 -55 -86 -74 -159 -70 -76 5 -127 39 -156
   106 -76 171 116 331 272 228z"/>
   <path d="M1651 2811 c-14 -25 1 -36 57 -45 44 -7 136 -47 147 -65 10 -18 -59
   -84 -113 -108 -40 -17 -52 -28 -48 -39 3 -9 6 -18 6 -20 0 -2 10 -4 23 -4 39
   1 101 35 140 79 l38 42 14 -35 c8 -20 15 -43 15 -53 0 -28 16 -45 36 -41 27 5
   22 72 -10 136 -44 87 -137 148 -253 166 -35 5 -44 3 -52 -13z"/>
   <path d="M1324 2515 c-16 -11 -16 -15 -5 -29 7 -9 19 -16 25 -16 24 0 112 -48
   139 -76 51 -51 62 -86 67 -217 0 -5 10 -7 23 -5 20 3 22 9 25 67 6 128 -69
   226 -210 274 -39 13 -50 13 -64 2z"/>
   <path d="M1656 2374 c-9 -24 -1 -31 53 -37 27 -3 67 -15 89 -26 36 -19 92 -78
   92 -99 0 -12 21 -20 38 -15 35 13 -11 102 -76 147 -51 35 -86 46 -142 46 -34
   0 -50 -4 -54 -16z"/>
   <path d="M1142 2090 c-66 -14 -157 -67 -212 -126 -55 -58 -58 -65 -34 -84 13
   -11 24 -4 77 48 60 59 147 109 167 97 33 -21 54 -170 30 -215 -14 -26 -2 -52
   23 -48 42 6 60 136 31 222 -9 26 -13 50 -10 54 4 3 35 -2 69 -11 92 -27 102
   -26 102 2 0 21 -8 28 -50 42 -66 22 -140 29 -193 19z"/>
   <path d="M1437 1843 c-2 -4 -7 -25 -11 -45 -9 -49 -55 -94 -114 -110 -37 -11
   -48 -19 -50 -37 -4 -23 -2 -24 47 -19 94 9 169 85 174 176 2 31 -1 37 -20 40
   -11 2 -23 0 -26 -5z"/>
   <path d="M1454 1486 c-10 -25 5 -35 71 -47 60 -11 126 -39 157 -66 15 -14 16
   -18 3 -43 -26 -50 -80 -89 -157 -114 -19 -6 -24 -41 -8 -51 6 -4 34 1 63 11
   37 12 68 33 109 74 l57 58 15 -42 c9 -22 19 -57 24 -76 6 -25 14 -35 28 -35
   31 0 30 63 -2 135 -50 112 -168 193 -301 207 -44 5 -54 3 -59 -11z"/>
   </g>
   </svg>
   
  )
}
export default BrainIcon;
